(() => {
  const root = document.getElementById('JwCustom');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const form = root.querySelector('#CustomRequest');
  const q = s => root.querySelector(s);
  const value = name => new FormData(form).get(`contact[${name}]`) || '';
  const lines = q('[data-order-lines]');
  const template = lines.firstElementChild.cloneNode(true);
  template.querySelector('[data-size]').value = 'M';
  lines.querySelector('[data-size]').value = 'M';
  const error = q('[data-error]');
  const review = q('[data-review]');
  let reviewed = false;
  function fail(message) { error.textContent = message; error.hidden = false; error.focus(); }
  function resetReview() { reviewed = false; review.hidden = true; q('[data-review-button]').hidden = false; error.hidden = true; }
  function sync() {
    const intent = value('request_type');
    for (const [selector, enabled] of [['[data-order-fields]', intent !== 'creator'], ['[data-creator-fields]', intent !== 'order']]) {
      const group = q(selector); group.hidden = !enabled;
      group.querySelectorAll('input,select,textarea,button').forEach(el => el.disabled = !enabled);
    }
    lines.querySelectorAll('[data-remove-row]').forEach(el => el.disabled = lines.children.length === 1);
    q('[data-add-row]').disabled = lines.children.length >= 30 || intent === 'creator';
    q('[data-quantities]').value = intent === 'creator' ? '' : [...lines.children].map(row => `${row.querySelector('[data-quantity]').value} × ${row.querySelector('[data-color]').value} / ${row.querySelector('[data-size]').value}`).join('\n');
  }
  q('[data-add-row]').addEventListener('click', () => { if (lines.children.length < 30) { lines.append(template.cloneNode(true)); resetReview(); sync(); } });
  lines.addEventListener('click', e => { if (e.target.closest('[data-remove-row]') && lines.children.length > 1) { e.target.closest('.order-line').remove(); resetReview(); sync(); } });
  form.addEventListener('input', () => { resetReview(); sync(); });
  form.addEventListener('change', () => { resetReview(); sync(); });
  q('[data-edit]').addEventListener('click', resetReview);
  form.addEventListener('submit', e => {
    sync();
    if (!form.reportValidity()) { e.preventDefault(); return; }
    let message = '';
    if (value('starting_point') === 'artwork' && !value('artwork_link') && !value('artwork_uploaded')) message = root.dataset.artRequired;
    else if (value('contact_method') === 'Phone' && !String(value('phone')).trim()) message = root.dataset.phoneRequired;
    const now = new Date();
    const today = new Intl.DateTimeFormat('en-CA', {timeZone:'America/Phoenix',year:'numeric',month:'2-digit',day:'2-digit'}).format(now);
    if (value('date') && value('date') < today) message = root.dataset.dateInvalid;
    if (message) { e.preventDefault(); fail(message); return; }
    if (reviewed && e.submitter === q('[data-confirm]')) return;
    e.preventDefault();
    q('[data-review-text]').textContent = [...new FormData(form)].filter(([k,v]) => k.startsWith('contact[') && String(v).trim()).map(([k,v]) => `${k.slice(8,-1).replaceAll('_',' ')}: ${v}`).join('\n');
    reviewed = true; review.hidden = false; q('[data-review-button]').hidden = true;
    review.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    q('[data-confirm]').focus();
  });
  sync();
})();
